<template>
  <div id="app">
    <keep-alive :include="caches">
      <router-view/>
    </keep-alive>
  </div>
</template>

<script>
import MenuListFordark from "./components/MenuListForDark.vue";
window.onload = function () {
  document.addEventListener('touchstart', function (event) {
    if (event.touches.length > 1) {
      event.preventDefault()
    }
  })
  document.addEventListener('gesturestart', function (event) {
    event.preventDefault()
  })
}
let clientWidth = document.body.clientWidth
export default {
  name: 'App',
  components: {
    MenuListFordark
  },
  data() {
    return {
      show: false,
      clientWidth,
    }
  },
  computed: {
    caches() {
      return this.$store.state.carbonApp.caches;
    }
  },
  watch: {
    $route (to, form) {
      if (clientWidth > 750) {
        if (to.path == '/index') {
          this.fordark = false
        } else {
          this.fordark = true
        }
        //  else if (to.path == '/Home'||to.path == '/tradingSystem'||to.path == '/rightsAndInterests'||to.path == '/carbonReduction'||to.path == '/greenFund') {
        //   this.fordark = true
        // }
      }
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style scoped>
#app {
  position: relative;
  /* padding-bottom: 6vw; */
  min-height: calc(100vh - 7vw);
  background-color: #F5F5F5;
}
.allStyleBgc {
  min-height: calc(100vh - 180px);
  background-image: url("./assets/images/latast_pc/thhz_pc_bgc.png") !important;
  background-repeat: no-repeat !important;
  background-size: 100% 100% !important;
}
.footer {
  height: 6vw;
  line-height: 8vw;
  position: absolute;
  bottom: 0%;
  color: #999;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 3vw;
  width: 100%;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue